export default "static/media/404.6c4e6f9.svg"